import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  deleteExternalGroupRelationAction,
  updateExternalGroupRelationAction,
  updateExternalGroupRelationFailure
} from '../actions';
import { transformDateToDB, DATE_FORMAT_CHARS, validateDates } from '../utils/dateFieldUtils';
import InputMask from 'react-input-mask';

class EgrList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openedEditSections: {},
      egrData:            {}
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.externalGroupRelations !== this.props.externalGroupRelations) {
      const egrs = this.props.externalGroupRelations.map(egr =>
        _.mapValues(egr, value => value ? value : ''));
      const egrData = _.fromPairs(egrs.map(egr =>
        [egr.externalGroupRelationId, _.omit(egr, ['externalGroupRelationId'])]));
      this.setState({ egrData });
    }
    if (prevProps.openedEditSections !== this.props.openedEditSections) {
      this.setState({ openedEditSections: this.props.openedEditSections });
    }
  }

  triggerEditSection(externalGroupRelationId, value) {
    this.setState({ openedEditSections:
      { ...this.state.openedEditSections, [externalGroupRelationId]: value } });
  }

  handleChange(egrId, keys, value) {
    const egr = _.cloneDeep(this.state.egrData[egrId]);
    _.set(egr, keys, value);
    this.setState({ egrData: { ...this.state.egrData, [egrId]: egr } });
  }

  generateInputForEgr(egrId, keys, isDate = false) {
    const value = this.state.egrData[egrId] ? _.get(this.state.egrData, [egrId, ...keys]) : '';
    if (isDate) {
      return (
        <InputMask
          placeholder="mm/dd/yyyy"
          type="text"
          mask="12/39/4599"
          value={value}
          onChange={e => this.handleChange(egrId, keys, e.target.value)}
          formatChars={DATE_FORMAT_CHARS}
        />
      )
    }
    return (
      <input
        type="text"
        value={value}
        onChange={e => this.handleChange(egrId, keys, e.target.value)}
      />
    );
  }

  generateLinkFor(targetType, targetURI, text) {
    const linkHref = `/${targetType}/${targetURI}`
    return <a href={linkHref} target='_blank'>{text}</a>
  }

  updateEgr(egr) {
    const data = this.state.egrData[egr.externalGroupRelationId];
    const errors = validateDates(data);
    if (!_.isEmpty(errors)) {
      this.props.updateExternalGroupRelationFailure(errors);
      return;
    }
    const args = {
      group_id:               data.group.id,
      external_group_id:      data.externalGroupId,
      external_group_type_cd: data.externalGroupTypeCd,
      state_cd:               data.stateCd,
      effective_start_dt:     transformDateToDB(data.effectiveStartDate),
      effective_end_dt:       transformDateToDB(data.effectiveEndDate)
    };
    this.props.updateExternalGroupRelationAction({
      id: egr.externalGroupRelationId,
      args
    });
  }

  renderEgrActions(egr) {
    if (this.props.hasBillingAccess) {
      return (
        <React.Fragment>
          <a
            className="edit"
            onClick={() => this.triggerEditSection(egr.externalGroupRelationId, true)}
          >
            Edit
          </a>
          <a
            className="delete"
            data-confirm="Are you Sure?"
            onClick={() =>
              this.props.deleteExternalGroupRelationAction(egr.externalGroupRelationId)}
          >
            Delete
          </a>
        </React.Fragment>
      );
    }
    return null;
  }

  render() {
    return (
      <div className="egr_list">
        {!_.isEmpty(this.props.externalGroupRelations) &&
          <table>
            <thead>
              <tr>
                <th>Group Id</th>
                <th>Legacy Group Id</th>
                <th>Vendor Group Id</th>
                <th>External Group Type</th>
                <th>State Restriction</th>
                <th>Effection Start Date</th>
                <th>Effective End Date</th>
                <th>Payer ID</th>
                <th>Modify</th>
              </tr>
            </thead>
            <tbody>
              {this.props.externalGroupRelations.map(egr => {
                // edit
                if (this.state.openedEditSections[egr.externalGroupRelationId]) {
                  return (
                    <tr key={egr.externalGroupRelationId}>
                      <td>{egr.group.id}</td>
                      <td>{egr.group.legacyGroupId}</td>
                      <td>
                        {this.generateInputForEgr(egr.externalGroupRelationId, ['externalGroupId'])}
                      </td>
                      <td>
                        <select
                          value={this.state.egrData[egr.externalGroupRelationId]
                            .externalGroupTypeCd}
                          onChange={e =>
                            this.handleChange(egr.externalGroupRelationId,
                              'externalGroupTypeCd',
                              e.target.value)}
                        >
                          {this.props.permittedTypeCodes.map((type, index) => (
                            <option value={type} key={index}>{type}</option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <select
                          value={this.state.egrData[egr.externalGroupRelationId].stateCd}
                          onChange={e =>
                            this.handleChange(egr.externalGroupRelationId,
                              'stateCd',
                              e.target.value)}
                        >
                          <option />
                          {this.props.stateCodes.map(([state, code], index) => (
                            <option value={code} key={index}>{state}</option>
                          ))}
                        </select>
                      </td>
                      <td>{this.generateInputForEgr(egr.externalGroupRelationId,
                        ['effectiveStartDate'], true)}</td>
                      <td>{this.generateInputForEgr(egr.externalGroupRelationId,
                        ['effectiveEndDate'], true)}</td>
                      <td>{egr.payer.id}</td>
                      <td>
                        <button
                          className="button"
                          type="button"
                          onClick={() => this.updateEgr(egr)}
                          disabled={this.props.isUpdating}
                        >
                          {this.props.isUpdating ? 'Submitting ...' : 'Submit'}
                        </button>
                        <button
                          className="button secondary"
                          type="button"
                          onClick={() =>
                            this.triggerEditSection(egr.externalGroupRelationId, false)}
                        >
                          Cancel
                        </button>
                      </td>
                    </tr>
                  );
                }
                // view
                return (
                  <tr key={egr.externalGroupRelationId}>
                    <td>{egr.group.id}</td>
                    <td>{this.generateLinkFor('groups', egr.group.id, egr.group.legacyGroupId)}</td>
                    <td>{egr.externalGroupId}</td>
                    <td>{egr.externalGroupTypeCd}</td>
                    <td>{egr.stateCd}</td>
                    <td>{egr.effectiveStartDate}</td>
                    <td>{egr.effectiveEndDate}</td>
                    <td>{egr.payer.id}</td>
                    <td>
                      {this.renderEgrActions(egr)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>}
      </div>
    );
  }
}

EgrList.propTypes = {
  updateExternalGroupRelationAction:  PropTypes.func,
  updateExternalGroupRelationFailure: PropTypes.func,
  externalGroupRelations:             PropTypes.array,
  openedEditSections:                 PropTypes.object,
  deleteExternalGroupRelationAction:  PropTypes.func,
  stateCodes:                         PropTypes.array,
  isUpdating:                         PropTypes.bool,
  hasBillingAccess:                   PropTypes.bool,
  permittedTypeCodes:                 PropTypes.array,
};

const mapStateToProps = state => ({
  openedEditSections: state.egrReducer.openedEditSections,
  isUpdating:         state.egrReducer.isUpdating
});

const mapDispatchToProps = {
  deleteExternalGroupRelationAction,
  updateExternalGroupRelationAction,
  updateExternalGroupRelationFailure
};

export default connect(mapStateToProps, mapDispatchToProps)(EgrList);
